
export class AuthData {
    username: string;
    userId: number;
    name : string;
    authorities: string[];
    token: string;
    tokenExpirationDate: Date;
    emailDrive: string;
    role: string;
}